import {
	instance
} from '../../util/http'
import apis from '../../config/apis'

// 销售审批记录
const salesApprovalsList = (SaleStatus,Page, PageSize) => {
	return instance.get(apis.Approval.GetUserSalesApprovalsByStatus + "?SaleStatus=" + SaleStatus +  "&Index=" + Page + "&Size=" + PageSize)
}

export default {
	salesApprovalsList,
}



